import { MainArea, Page, Error, Button, Box, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Actions as Router } from 'router';

interface DispatchProps {
  push: (href: string) => void;
}

function NotFoundPage(props: DispatchProps) {
  const { t } = useTranslation('error');

  return (
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>
      <Page padding={50}>
        <Box stackItems={true}>
          <Error heading={t('notFound.heading')} description={t('notFound.description')} />
          <Box horizontalPositioning="center">
            <Button
              variation="secondary"
              onClick={() => {
                props.push('/');
              }}
            >
              {t('notFound.gotoDashboardButton.label')}
            </Button>
          </Box>
        </Box>
      </Page>
    </MainArea>
  );
}

const actions: DispatchProps = {
  push: Router.push,
};

export default connect(null, actions)(NotFoundPage);
